/**
 * @generated SignedSource<<6e06631fd5c1a427fcedfc104d531da1>>
 * @relayHash 803e39947b70ac467814f070c57b706a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b8fa657ba6456c1311351ec38eb39d6af0da4fac0828be3a57715639b77f3289

import type { ConcreteRequest } from 'relay-runtime';
export type SettingsDisplayPropertyInput = {
  key: string;
  value: string;
};
export type useSideNavToggleStateMutation$variables = {
  entityAri: string;
  ownerAri?: string | null;
  properties?: ReadonlyArray<SettingsDisplayPropertyInput | null> | null;
};
export type useSideNavToggleStateMutation$data = {
  readonly settings_updateNavigationCustomisation: {
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
  } | null;
};
export type useSideNavToggleStateMutation = {
  response: useSideNavToggleStateMutation$data;
  variables: useSideNavToggleStateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ownerAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "properties"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityAri",
        "variableName": "entityAri"
      },
      {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
      },
      {
        "kind": "Variable",
        "name": "properties",
        "variableName": "properties"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 20
    }
  ],
  "concreteType": "SettingsDisplayPropertyConnection",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "SettingsDisplayProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "storageKey": "properties(first:20)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSideNavToggleStateMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_updateNavigationCustomisation",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSideNavToggleStateMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_updateNavigationCustomisation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b8fa657ba6456c1311351ec38eb39d6af0da4fac0828be3a57715639b77f3289",
    "metadata": {},
    "name": "useSideNavToggleStateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "5a80f198830ab4e567f668a307962556";

export default node;
